<template>
  <section class="naming-logos">
    <h2 class="text-h6">Logo Logic</h2>
    <v-row>
      <v-col col="12"> </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="item in doc.list"
        :key="`logo-${item.name}-${id}-${item.id}`"
        :cols="getCols"
        class="text-center"
      >
        <div class="parent-logo">
          <div
            class="filled"
            :style="{ borderColor: item.color, background: item.color }"
          ></div>
          <h1 class="text-center">{{ item.title }}</h1>
        </div>
        <v-row>
          <v-col
            v-for="child in item.children"
            :key="`child-${child.name}-${id}-${child.id}`"
            cols="4"
          >
            <div class="naming-logo">
              <div
                :class="getShape(child, item)"
                :style="getStyle(child, item)"
              ></div>

              <h2 class="">{{ getName(child) }}</h2>
              <p>{{ getEndorsement(child, item) }}</p>
            </div>

            <div
              v-for="sub in child.children"
              :key="`sub-${sub.name}-${id}`"
              class=""
            >
              <div class="location-logo">
                <div
                  :class="getShape(sub, child)"
                  :style="getStyle(sub, child)"
                ></div>

                <h2 class="">
                  {{ getName(sub) }}
                </h2>
                <p>{{ getEndorsement(sub, item) }}</p>
                <!-- // start child  -->
                <div
                  v-for="minor in sub.children"
                  :key="`minor-${minor.name}-${id}`"
                  class=""
                >
                  <div class="location-logo small-logo">
                    <div
                      :class="getShape(minor, child)"
                      :style="getStyle(minor, child)"
                    ></div>

                    <h2 class="">
                      {{ getName(minor) }}
                    </h2>
                    <p class="">
                      {{ getEndorsement(minor, item) }}
                    </p>
                  </div>
                </div>
                <!-- // end child  -->
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  name: "NamingLogos",
  data() {
    return {};
  },
  props: {
    cols: {
      type: Number,
      default: 4,
    },
    id: {
      type: String,
      default: "diushoaidcs",
    },
    doc: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {},
  computed: {
    getCols() {
      if (this.doc.listNames) {
        const l = this.doc.listNames.length;
        switch (l) {
          case 1:
            return 12;
          case 2:
            return 6;
          case 3:
            return 4;
          case 4:
            return 3;
          default:
            return 4;
        }
      } else {
        return 12;
      }
    },
  },
  methods: {
    getColor(col) {
      switch (col) {
        case 0:
          return "#009688";
        case 1:
          return "#F44336";
        case 2:
          return "#673AB7";
        case 3:
          return "#1B5E20";
        case 4:
          return "#2196F3";
        default:
          return "#E91E63";
      }
    },
    getStyle(el, parent) {
      if (el.brand === "Standalone") {
        const col = el.color ? el.color : "";
        return { borderColor: col, background: col };
      }
      if (el.brand === "Brand") {
        const col = el.color ? el.color : parent.color;
        return { borderColor: col, background: col };
      }
      if (el.brand === "Sub-brand") {
        const col = el.color ? el.color : parent.color;
        return { borderColor: col };
      }
      const col = parent.color ? parent.color : "";
      return { borderColor: col, background: col };
    },
    getShape(el, parent) {
      if (el.brand === "Brand") {
        return "diamond";
      }
      if (el.brand === "Sub-brand") {
        if (parent.brand === "Brand") {
          return "diamond";
        }
        if (parent.brand === "Standalone") {
          return "filled";
        }
        return "circle";
      }
      if (el.brand === "Standalone") {
        return "filled";
      }
    },
    getEndorsement(el, parent) {
      // console.log("getEndorsement", el);
      if (el.endorsed === "Parent") {
        return parent.title;
      }
      if (el.endorsed === "Master") {
        return this.doc.master;
      }
      if (el.endorsed === "None") {
        return "";
      }
      return parent.title;
    },
    getName(el) {
      if (this.doc.prefix && el.allowPrefix) {
        switch (this.doc.prefixPosition) {
          case "after":
            return `${el.name}${this.doc.prefix}`;
          case "after-space":
            return `${el.name} ${this.doc.prefix}`;
          case "before":
            return `${this.doc.prefix}${el.name}`;
          case "before-space":
            return `${this.doc.prefix} ${el.name}`;
        }
      } else {
        return el.name;
      }
    },
  },
};
</script>

<style lang="scss"></style>
